export interface SubtitleEditngBoxProps {
  isMobileVariant: boolean;
  isSelected?: boolean;
  text: string;
  subtitleId: string;
  startTime: number;
  endTime: number;
  disableMergeWithNextOption?: boolean;
  disableMergeWithPreviousOption?: boolean;
  disableAddAfter?: boolean;

  autoFocus?: boolean;
  setAutoFocus?(autoFocus: boolean): void;

  onSubtitleTextChange(id: string, subtitleText: string, isUndoable?: boolean): void;
  onSubtitleDelete(id: string): void;
  onSubtitleBoxFocussed(id: string): void;

  onKeyDown(currentSubtitleId: string, key: SubtitlesEditorKeyDown, caretPosition?: number): void;

  onMergeSubtitles(currentSubtitleId: string, mergeWith: MergeSubtitleWith): void;

  onAddSubtitleAfter(idOfSubtitleToAddAfter: string): void;
  onPlayPauseSubtitle(subtitleId: string): void;
}

export enum SubtitlesEditorKeyDown {
  DOWN = 'down',
  UP = 'up',
  ENTER = 'enter',
  BACKSPACE = 'backspace',
}

export enum MergeSubtitleWith {
  NEXT = 'next',
  PREVIOUS = 'previous',
}
